<template>
  <div class="loading-state">
    <font-awesome-icon pulse :icon="['fal', 'spinner']"/>
    <p class="message">{{ $t('loading_message') }}</p>
  </div>
</template>

<script>
  export default {
    name: "loading-state",
    i18nOptions: {namespaces: ['state']},
  }
</script>

<style scoped>
  .loading-state {
    width: 100%;
    padding: 90px 0;
    text-align: center;
    color: #999;
  }

  .svg-inline--fa {
    display: inline-block;
    width: 45px;
    height: 45px;
  }

  .message {
    margin-top: 20px;
  }
</style>
